




import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class ConnectionMessage extends Vue {
  connectionMessageVisible = false;
  connectionMessage: any = null;

  mounted() {
    setInterval(() => {
      this.checkForConnection();
    }, 5000);
  }

  checkForConnection() {
    const requiresAuth = Boolean(this.$router.currentRoute.meta.requiresAuth);

    this.$store
      .dispatch("settings/updates")
      .then(() => {
        if (this.connectionMessageVisible && requiresAuth) {
          this.connectionMessageVisible = false;
          this.connectionMessage.close();
          this.$notify({
            title: "Connection restored!",
            message: "",
            type: "success",
            showClose: false,
          });
        }
      })
      .catch(() => {
        if (!this.connectionMessageVisible && requiresAuth) {
          this.connectionMessageVisible = true;

          this.connectionMessage = this.$notify({
            title: "No connection...",
            message: "Trying to restore your connection.",
            type: "error",
            duration: 0,
            showClose: false,
          });
        }
      });
  }
}
